import styled from 'styled-components';
import { device } from 'commons';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ProductsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media (max-width: ${device.tablet}px) {
    align-items: center;
  }
`;

export const Product = styled.div`
  display: flex;
  gap: 45px;
  border: 1px solid ${({ theme }) => theme.neutral_300};
  border-radius: 10px;
  overflow: hidden;
`;

export const EanContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 250px;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  gap: 2px;
  padding-top: 17px;
`;

export const CheckboxLabel = styled.label`
  font-size: 10px;
  font-weight: 600;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px 20px;
`;
